import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialMagnet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.09 16.76h4.58v7.62h1.52V10.67h-7.62v13.71h1.52z\"/><path fill=\"currentColor\" d=\"M25.14 24.38h1.53v3.05h-1.53Zm-1.52 3.05h1.52v1.52h-1.52Zm0-27.43h1.52v1.52h-1.52Zm-1.53 6.1h1.53v1.52h-1.53Zm0-4.58v1.53h-1.52v1.52h3.05V6.1h1.52V4.57h1.53V3.05h-3.05V1.52zm-1.52 27.43h3.05v1.53h-3.05Zm-9.14 1.53h9.14V32h-9.14Zm0-6.1h9.14v1.52h-9.14Zm-3.05 4.57h3.05v1.53H8.38Zm-1.52-1.52h1.52v1.52H6.86ZM6.86 0h1.52v1.52H6.86ZM5.33 24.38h1.53v3.05H5.33Zm0-18.28h1.53v1.52H5.33Zm0-4.58v1.53H3.81v1.52h3.05V6.1h1.52V4.57H9.9V3.05H6.86V1.52zM3.81 24.38h1.52v-7.62H9.9v7.62h1.53V10.67H3.81z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialMagnet
